import {NamedEntity, NamedEntityModel} from './named-entity.model';

export const API_KEY_LENGTH = 40;
export const API_KEY_MAX_KEYS_PER_USER = 2;
export const API_KEY_EXPIRATION_WARNING_DAYS = 30;

export interface ApiKey extends NamedEntity {
  key: string;
  expires_at: string | null;
}

export class ApiKeyModel extends NamedEntityModel<ApiKey> {
  readonly key: string;
  readonly expiresAt: Date | null;

  constructor(source: ApiKey) {
    super(source);
    this.key = source.key;
    this.expiresAt = source.expires_at ? new Date(source.expires_at) : null;
  }

  get expired(): boolean {
    return this.expiresAt !== null && this.expiresAt <= new Date();
  }

  get expiringSoon(): boolean {
    if (!this.expiresAt || this.expired) return false;
    const warningDate = new Date();
    warningDate.setDate(warningDate.getDate() + API_KEY_EXPIRATION_WARNING_DAYS);
    return this.expiresAt <= warningDate;
  }

  get daysUntilExpiration(): number | null {
    if (!this.expiresAt) return null;
    const now = new Date();
    const diffMs = this.expiresAt.getTime() - now.getTime();
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  }
}
